<script>
    import { getFlamelinkWearTesters } from '../../services/flamelink'
    let getP1TesterPromise = getFlamelinkWearTesters(1);
    let getP2TesterPromise = getFlamelinkWearTesters(2);
</script>

<style>
    .wear_tester_badge_grid_container {
        display: grid;
        grid-template-columns: auto auto;
        grid-template-rows: auto;
        column-gap: 15px;
        row-gap: 70px;
        padding-bottom: 140px;
        max-width: 500px;
    }

    .wear_tester_badge_grid_slot {
        width: 100%;
        padding-top: 158%;
        position: relative;
    }

    .no_hover:hover {
        color: white !important;
    }
</style>

{#await getP2TesterPromise}
    <div height="1500px"/> <!-- This is where you can put "loading content" -->
{:then testers}

<h1 class="header_text" style="margin-top: 20px">{`PHASE TWO`}</h1>
<p class="body_text">
  Introducing our Phase Two Group (001 - 082). Follow each of their journeys on
  their individual Instagram.
</p>

<div class="wear_tester_badge_grid_container">
        {#each testers as tester, i}
            <div class="wear_tester_badge_grid_slot">
                <img src={tester.fallbackBadgeImageUrl} alt="" style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; object-fit: cover"/>
                {#if tester.igLink.includes("https")}
                 <a href={tester.igLink} target="_blank" class="body_text no_hover" style="position: absolute; bottom: -30px; text-decoration: underline; height: 30px; word-break: break-word;">{tester.name}</a>
                {/if}
                {#if !tester.igLink.includes("https")}
                    <!-- <p class="body_text no_hover" style="position: absolute; bottom: -30px; text-decoration: underline; height: 30px; word-break: break-word;">{tester.name}</p> -->
                {/if}
                 <!-- <p class="body_text" style="position: absolute; bottom: -65px; height: 30px; overflow: break-word ">{tester.location}</p> -->
            </div>
        {/each}
</div>
{/await}


{#await getP1TesterPromise}
    <div height="1500px"/> <!-- This is where you can put "loading content" -->
{:then testers}

<h1 class="header_text" style="margin-top: 20px">{`PHASE ONE`}</h1>
<p class="body_text">
      Introducing our Phase One Group (001 - 150). Follow each of their journeys on
  their individual Instagram.
</p>

<div class="wear_tester_badge_grid_container">
        {#each testers as tester, i}
            <div class="wear_tester_badge_grid_slot">
                <img src={tester.fallbackBadgeImageUrl} alt="" style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; object-fit: cover"/>
                {#if tester.igLink.includes("https")}
                 <a href={tester.igLink} target="_blank" class="body_text no_hover" style="position: absolute; bottom: -30px; text-decoration: underline; height: 30px; word-break: break-word;">{tester.name}</a>
                {/if}
                 <!-- <p class="body_text" style="position: absolute; bottom: -65px; height: 30px; overflow: break-word ">{tester.location}</p> -->
            </div>
        {/each}
</div>
{/await}

